import axios from 'axios';
import qs from 'qs';
import { BASE_URL } from './variables';
import Router from '../../src/router';
// import vue from '../main'

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// axios config
axios.defaults.timeout = 20000;
const debug = process.env.NODE_ENV === 'production';
axios.defaults.baseURL = localStorage.BASE_URL;
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['labtoken'] = localStorage.Labtoken;

let isNoProgress = true;

axios.interceptors.request.use(
    config => {
        config.baseURL = localStorage.BASE_URL;
        return config;
    },
    error => {
        alert('errror params');
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.status === 401) {
                // localStorage.removeItem('Labtoken')
                // Router.push('/o/login')
                if (isNoProgress) NProgress.done();
            } else if (response.data.status === 400) {
                this.$message.error('服务器请求错误');
                // return response
            } else if (response.data.status === 500) {
                this.$message.error('服务器无法完成请求');
                // return response
            }
        } else {
        }

        return response;
    },
    error => {
        return Promise.reject(error.response);
    }
);

export default axios;
